module.exports = __webpack_public_path__ + "img/screenshot-2.ad2c2c02.png";